module.exports = __webpack_public_path__ + "static/media/sukses.bcbb393b.jpg";